import { RegulatorFetchError } from "../../../api/regulator";
import { metricAccessRight } from "./widgetCatalog";

/**
 * Droits bigdata vus par le configurateur du widget régulateur. `ok` : droits connus, on
 * verrouille ce qui manque et on purge la config. `forbidden` : aucun accès, tout ce qui demande
 * un droit est verrouillé, sans rien effacer. Les autres états ne verrouillent ni n'effacent :
 * une panne ou l'absence de bâtiment ne disent rien des droits (avant, une erreur valait
 * « aucun droit » et vidait la sélection de l'utilisateur).
 */
export type RegulatorRights =
  | { kind: "ok"; granted: string[] }
  | { kind: "forbidden" | "unknown" | "unavailable" | "no-building" };

export function regulatorRights(state: {
  deviceUuid?: string;
  loading: boolean;
  error: RegulatorFetchError | "";
  buildingId?: number;
  granted: string[];
}): RegulatorRights {
  if (state.deviceUuid === undefined || state.loading)
    return { kind: "unknown" };
  if (state.error === "forbidden") return { kind: "forbidden" };
  if (state.error !== "") return { kind: "unavailable" };
  if (state.buildingId === undefined) return { kind: "no-building" };
  return { kind: "ok", granted: state.granted };
}

/** Droit qui verrouille cette grandeur, ou `undefined` si elle reste libre. */
export function missingRight(
  rights: RegulatorRights,
  metric: string,
  deviceType?: string
): string | undefined {
  const required = metricAccessRight(metric, deviceType);
  if (!required) return undefined; // grandeur sans droit requis (ex. effectif)
  if (rights.kind === "forbidden") return required;
  if (rights.kind !== "ok") return undefined;
  return rights.granted.includes(required) ? undefined : required;
}
